// extracted by mini-css-extract-plugin
export default {"root":"PQ_A8Gtt30PFojEFbKt2","item":"G2S5TV880DBc016SQhAg","open":"DA8vsfAlJynk6phSKXvx","folder":"OffI0orEe6oGjXJMjVu2","chevron":"_q9bZSgtxJe5yasUH3iX"};